/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Card, useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../Redux Store/actions";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import cssClasses from "./PreselectAllotments.module.css";
import ReactTimeAgo from "react-time-ago";

import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { getPreselectConfirmations, getPreselectConfirmationsConfig } from "../../Services/Allotment";
// import ThreeDotsMenu from '../../Subcomponents/ThreeDotsMenu';
import EmptyListIcon from "../../Assets/Images/EmptyDataIcons/Artwork.svg";
import Button from "../../Subcomponents/Button";
import MyTimer from "../../Subcomponents/Timer";
import PreselectConfirmation from "../../Modals/PreselectConfirmation/PreselectConfirmation";
import { supabase } from "../../supabaseClient";
import PreselectBuildingIcon from "../../Assets/Images/Common/AllotmentBuildingIcon.svg";
import PreselectCalenderIcon from "../../Assets/Images/Common/AllotmentCalender.svg";
import { getTokenServerTime } from "../../Services/Tokens";
import AllotmentInfoIcon from "../../Assets/Images/Common/info-circle.svg";
import { Tooltip } from "react-tooltip";
import PreselectAllotmentCard from "./PreselectAllotmentCard";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import Congratulation from "../../Modals/PreselectConfirmation/Congratulation";

const PreselectAllotments = () => {
	const dispatch = useDispatch();
	// const [allAllotments, setAllAllotments] = useState([]);
	const [allotment, setAllotment] = useState({});
	const [_allotment, set_Allotment] = useState({});
	const [allotmentsPresent, setAllotmentsPresent] = useState(null);
	const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
	const [openCong, setOpenCong] = useState(false);

	const [serverTime, setServerTime] = useState(new Date().getTime());
	const [updatedRecord, setUpdatedRecord] = useState([]);
	const allAllotments = useRef([]);
	const update = useRef([]);
	//   const [dep, setDep] = useState(null);
	const [updatedData, setupdatedData] = useState([]);
	//   const [condtion, setCondtion] = useState({
	//     showConfirmBtn: false,
	//     showMsg: false,
	//   });
	const isWrap = useMediaQuery("(max-width:1024px)");
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	TimeAgo.setDefaultLocale(en.locale);
	TimeAgo.addLocale(en);
	const getServerTime = async () => {
		getTokenServerTime()
			.then((res) => {
				setServerTime(res?.data?.currentTime);
			})
			.catch((error) => {
				console.log("err in getQueueStatus api call", error);
			});
	};
	useEffect(() => {
		setTimeout(() => {
			getServerTime();
		}, 1000);
	}, []);
	useEffect(() => {
		dispatch(actions.activeMenu("preselect"));
		getTokenServerTime()
			.then((res) => {
				setServerTime(res?.data?.currentTime);
				getLeadConfirmations(res?.data?.currentTime);
			})
			.catch((error) => {
				console.log("err in getQueueStatus api call", error);
			});
		//  getLeadConfirmations();
		let insertUnitListener = supabase
			.from(`AllotmentPayment`)
			.on("INSERT", (handleRecordUpdated) => {
				if (handleRecordUpdated.new.leadId === loggedInUser.leadId) {
					getLeadConfirmations();
				}
			})
			.subscribe((status) => {
			});
		// ! commenting below listener as timer and msg issue.
		let updateEventListener = supabase
			.from(`PreselectConfirmationConfig`)
			.on("UPDATE", (handleRecordUpdated) => {
				if (handleRecordUpdated) {
					// getServerTime();
					let data = [];
					const newData = allAllotments.current.map((allotment) => {
						if (
							handleRecordUpdated?.new?.launchId === allotment?.launchId &&
							handleRecordUpdated.new.eventId === allotment?.paymentId?.eventId?.eventId &&
							handleRecordUpdated.new.eventTokenId === allotment?.paymentId?.eventTokenId?.eventTokenId
						) {
							data = [...data, handleRecordUpdated];
							allotment.paymentId.eventId.preselectConfirmationConfig = handleRecordUpdated.new.preselectConfirmationConfig;
							return allotment;
						} else {
							return allotment;
						}
					});
					allAllotments.current = newData;
					if (data.length > 0) {
						setupdatedData(data);
					}
					//  setUpdatedRecord((pre) => pre.length <5 ? [...pre, handleRecordUpdated] : [handleRecordUpdated]);
				}
			})
			.subscribe((status) => {
			});
		let updateUnitListener = supabase
			.from(`AllotmentPayment:leadId=eq.${loggedInUser.leadId}`)
			.on("UPDATE", (handleRecordUpdated) => {
				getLeadConfirmations();
			})
			.subscribe((status) => {
			});
		return () => {
			if (insertUnitListener) {
				supabase.removeSubscription(insertUnitListener);
				insertUnitListener = null;
			}
			if (updateUnitListener) {
				supabase.removeSubscription(updateUnitListener);
				updateUnitListener = null;
			}
			if (updateEventListener) {
				supabase.removeSubscription(updateEventListener);
				updateEventListener = null;
			}
			// if (updateEventTokenListener) {
			//     supabase.removeSubscription(updateEventTokenListener);
			//     updateEventTokenListener = null;
			// }
		};
	}, []);

	useEffect(() => {
		// console.log("updated data==>", updatedData);
	}, [updatedData]);

	function getLeadConfirmations(time = serverTime) {
		presentLoader();
		getPreselectConfirmations(loggedInUser.leadId)
			.then(async (resp) => {
				const payload = [...resp?.data];
				console.log('payload',payload);
				
				allAllotments.current = payload;

				if (resp.count > 0) {
					setAllotmentsPresent(true);
				} else {
					setAllotmentsPresent(false);
				}
				dismissLoader();
			})
			.catch((err) => {
				console.log("err: ", err);
				dismissLoader();
			});
	}

	function UpdatePreselectUpdate(respValue) {
		if (respValue === true) {
			// getLeadConfirmations();
			setOpenConfirmationModal(false);
			setOpenCong(true);
		} else {
			getLeadConfirmations();
		}
	}

	return (
		<div className={cssClasses.wrapperTargetPage}>
			<div className={cssClasses.preselectWrapContent}>
				<div className={cssClasses.headerMainContent}>
					<div className={cssClasses.wrapperHeader}>
						<div className={cssClasses.headerTitle}>{allAllotments.current.length} Pre-select Confirmations</div>
					</div>
				</div>
				<div className={cssClasses.eventsWrapper}>
					{/* {allotmentsPresent && (
                    <div className={cssClasses.headerSubTitle}>
                        {totalAllotments} Pending Pre-select Confirmations
                    </div>
                )} */}
					{allotmentsPresent &&
						allAllotments.current.map((allotment, index) => (
							<PreselectAllotmentCard
								key={index}
								allotment={allotment}
								serverTime={serverTime}
								setOpenConfirmationModal={setOpenConfirmationModal}
								setAllotment={setAllotment}
								getLeadConfirmations={getLeadConfirmations}
								numberWithCommas={numberWithCommas}
								updatedRecord={updatedData}
							/>
						))}
					{allotmentsPresent === false && (
						<div className={cssClasses.noDataWrapper}>
							<div className={cssClasses.noDataMsg}>
								<div className={cssClasses.emptyIcon}>
									<img src={EmptyListIcon} alt="No Allotments" />
								</div>
								<div className={cssClasses.emptyTitle}>No Preselect Confirmations to show!</div>
							</div>
						</div>
					)}
				</div>
			</div>

			<PreselectConfirmation
				allotmentDetails={allotment}
				open={openConfirmationModal}
				handleClose={() => setOpenConfirmationModal(false)}
				returnResp={UpdatePreselectUpdate}
			/>

			{openCong && (
				<Congratulation
					open={openCong}
					handleClose={() => setOpenCong(false)}
					time={3000}
				/>
			)}
		</div>
	);
};
export default PreselectAllotments;
